// extracted by mini-css-extract-plugin
module.exports = {"boardWrapper":"Board_boardWrapper__2wirF","board":"Board_board__LvW07","muteBtn":"Board_muteBtn__3-ZCF","muted":"Board_muted__1X3jB"};